console.log('Eric - Full Stack Developer');
console.log('email: ericjohnariate@gmail.com');

const selluxeSliders = document.querySelectorAll('.selluxe-slider') || null;

if(selluxeSliders) {
  selluxeSliders.forEach(slider => {
    const sliderId = slider.dataset.sliderId;
    const sliderOptions = JSON.parse(slider.dataset.sliderOptions);

    console.log(sliderId);
    console.log(sliderOptions);

    const selluxeSlider = new Swiper(`#${sliderId}`, sliderOptions);
  });
}
